import { cognitoErrors } from './services';
import { isLti } from './util';
import { privateInstance, publicInstance, ltiInstance, downloadInstance } from './instances';

//Async method to get data from server
export const getData = async (service, isReturnError = false, isBlobResponse = false) => {
  return new Promise(async (resolve, reject) => {
    return (isLti() ? ltiInstance : privateInstance)
      .get(service, { useBlob: isBlobResponse ? true : false })
      .then((data) => resolve(data))
      .catch((err) => {
        //only reject if the rejection is expected, else the app renders errors on the main page
        if (isReturnError) reject(err);
      });
  });
};

export const downloadData = async (service, isReturnError = false) => {
  try {
    return await downloadInstance.get(service);
  } catch (err) {
    if (isReturnError) {
      // Propagate the error to the caller
      throw err;
    }
    // Otherwise swallow or handle it here, and return null or undefined
    console.error('Download error:', err);
    return null;
  }
};

//Async method to get data from server for Public routes
export const getDataPublic = async (service, isReturnError = false) => {
  return new Promise(async (resolve, reject) => {
    return publicInstance
      .get(service)
      .then((data) => resolve(data))
      .catch((err) => {
        //only reject if the rejection is expected, else the app renders errors on the main page
        if (isReturnError) reject(err);
      });
  });
};

//Async method to post data to server
export const postData = async (service, body, isReturnError = false) => {
  return new Promise(async (resolve, reject) => {
    return (isLti() ? ltiInstance : privateInstance)
      .post(service, body)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        //only reject if the rejection is expected, else the app renders errors on the main page
        if (isReturnError) reject(err);
      });
  });
};

//Async method to post data to server for public routes
export const postDataPublic = async (service, body, isReturnError = false) => {
  return new Promise(async (resolve, reject) => {
    return publicInstance
      .post(service, body)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        //only reject if the rejection is expected, else the app renders errors on the main page
        if (isReturnError) reject(err);
      });
  });
};

//Async method to post data to server for public routes
export const patchDataPublic = async (service, body, isReturnError = false) => {
  return new Promise(async (resolve, reject) => {
    return publicInstance
      .patch(service, body)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        //only reject if the rejection is expected, else the app renders errors on the main page
        if (isReturnError) reject(err);
      });
  });
};

//Async method to put data to server
export const putData = async (service, body, isReturnError = false) => {
  return new Promise(async (resolve, reject) => {
    return (isLti() ? ltiInstance : privateInstance)
      .put(service, body)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        //only reject if the rejection is expected, else the app renders errors on the main page
        if (isReturnError) reject(err);
      });
  });
};

//Async method to patch data to server
export const patchData = async (service, body, isReturnError = false) => {
  return new Promise(async (resolve, reject) => {
    return (isLti() ? ltiInstance : privateInstance)
      .patch(service, body)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        //only reject if the rejection is expected, else the app renders errors on the main page
        if (isReturnError) reject(err);
      });
  });
};

//Async method to delete data from server
export const deleteData = async (service, body = {}, isReturnError = false) => {
  return new Promise(async (resolve, reject) => {
    return (isLti() ? ltiInstance : privateInstance)
      .delete(service, body)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        //only reject if the rejection is expected, else the app renders errors on the main page
        if (isReturnError) reject(err);
      });
  });
};

export const logCognitoError = async (cognitoError) => {
  postDataPublic(cognitoErrors, cognitoError);
};
